/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { TechStackService } from './services/tech-stack.service';
import { TechStackTemplateService } from './services/tech-stack-template.service';
import { VendorService } from './services/vendor.service';
import { ProductService } from './services/product.service';
import { InstallService } from './services/install.service';
import { SupportService } from './services/support.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    TechStackService,
    TechStackTemplateService,
    VendorService,
    ProductService,
    InstallService,
    SupportService,
    ApiConfiguration
  ],
})
export class AdminBuyersCaddyApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<AdminBuyersCaddyApiModule> {
    return {
      ngModule: AdminBuyersCaddyApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: AdminBuyersCaddyApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('AdminBuyersCaddyApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
